export const ENV_PROPS = {
  "env": "production",
  "region": "",
  "project_id": ""
};
